import { render, staticRenderFns } from "./TestimonialCards.vue?vue&type=template&id=42fe881a&scoped=true&"
import script from "./TestimonialCards.vue?vue&type=script&lang=ts&"
export * from "./TestimonialCards.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialCards.vue?vue&type=style&index=0&id=42fe881a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fe881a",
  null
  
)

export default component.exports